var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageTracks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.5V10.2222C15 10.9442 14.7089 11.6366 14.1907 12.1471C13.6725 12.6576 12.9697 12.9444 12.2368 12.9444C11.504 12.9444 10.8012 12.6576 10.283 12.1471C9.7648 11.6366 9.47368 10.9442 9.47368 10.2222C9.47368 9.50024 9.7648 8.80784 10.283 8.29732C10.8012 7.78681 11.504 7.5 12.2368 7.5C12.6632 7.5 13.0658 7.59333 13.4211 7.76444V3.19889L5.52632 4.85556V11.7778C5.52632 12.4998 5.2352 13.1922 4.71701 13.7027C4.19881 14.2132 3.49599 14.5 2.76316 14.5C2.03032 14.5 1.3275 14.2132 0.80931 13.7027C0.291118 13.1922 0 12.4998 0 11.7778C0 11.0558 0.291118 10.3634 0.80931 9.85288C1.3275 9.34236 2.03032 9.05556 2.76316 9.05556C3.18947 9.05556 3.59211 9.14889 3.94737 9.32V2.83333L15 0.5Z",
    fill: "#AEB9E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageTracks);
export default __webpack_public_path__ + "static/media/manage-tracks.05417eff15d10ed69bf0f88f275684d4.svg";
export { ForwardRef as ReactComponent };